import { Text } from '@/components/shared/element/text';
import { Section } from '@/components/shared/layout/section';
import { Image } from '@/components/shared/media/image';
import { generateLargeDesktopAndDesktopImageSources } from '@/components/shared/media/image/generate-sources';
import {
  DEFAULT_IMAGE,
  ImageProps,
} from '@/components/shared/media/image/Image.props';

interface DealerResultBeforeSearchProps {
  imageMobile?: ImageProps;
  imageDesktop?: ImageProps;
  message: string;
}
export const DealerResultBeforeSearch: React.FunctionComponent<
  DealerResultBeforeSearchProps
> = (props: DealerResultBeforeSearchProps) => {
  return (
    <Section
      as="div"
      test="dealer_result_before_search"
      css={{
        '@maxlg': {
          display: 'none',
        },
      }}
    >
      <Image
        priority
        src={DEFAULT_IMAGE}
        alt={props.imageDesktop?.alt ?? ''}
        width={props.imageDesktop?.width ?? 0}
        height={props.imageDesktop?.height ?? 0}
        layout="responsive"
        aspectRatio="21by9"
        sources={[
          ...generateLargeDesktopAndDesktopImageSources({
            desktopSrc: props.imageDesktop?.src,
            desktopOptions: {
              crop: '21:9',
            },
          }),
        ]}
      />
      <Text
        as="p"
        size="h2"
        variant="text-white"
        wrap
        dangerouslySetInnerHTML={{
          __html: props.message,
        }}
        css={{
          textAlign: 'center',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: '1',
        }}
      />
    </Section>
  );
};

DealerResultBeforeSearch.displayName = 'DealerResultBeforeSearch';
